import React from 'react';

import SalesLimitTableRow from './SalesLimitTableRow';

class SalesLimitTable extends React.Component {
  _onSalesLimitChange(ident) {
    return value => {
      this.props.onSalesLimitChange(ident, value);
    };
  }

  render() {
    const {
      salesLimitRows,
      inputId,
      newMode,
      editMode
    } = this.props;

    return (
      <table className="widefat fixed striped parkchirp--sales-limit-table">
        <thead>
          <tr>
            <td>Month</td>
            <td>Sales Limit</td>
            <td>Sold</td>
            <td>Terminating</td>
            <td>Total</td>
          </tr>
        </thead>
        <tbody>
          {salesLimitRows.map(salesLimitRow => {
            return (
              <SalesLimitTableRow inputId={inputId}
                key={salesLimitRow.ident}
                ident={salesLimitRow.ident}
                salesLimit={salesLimitRow.data}
                onValueChange={this._onSalesLimitChange(salesLimitRow.ident)}
                // newMode={newMode}
                editMode={editMode}
              />
            );
          })}
        </tbody>
      </table>
    );
  }
}

export default SalesLimitTable;
